const styles = {
    MembersContainer: {

        backgroundColor: '#f5f7fa',
    }, 
    MembersHeaderCell:   {
              color: "#6E6893",
            //   textAlign: "center",
              fontFeatureSettings: "'clig' off, 'liga' off",
              fontWeight: 700,
              fontFamily: "Montserrat, Sans-serif",
              fontSize: "17px",
              fontStyle: "normal",
              lineHeight: "21px",
              textTransform: "uppercase",
        background: "#F4F2FF",
              
    },
    NameAvatarBox: {
        display: 'flex',
        //center items vertically
        alignItems: 'center',
        gap: '15px',
    },
    NameAgeBox: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: '10px'
    },
    NameType: {
        color: 'var(--Fonts-Primary, #25213B)',
        fontFeatureSettings: "'clig' off, 'liga' off",
        fontFamily: 'Montserrat',
        fontSize: '25.934px',
        fontStyle: 'normal',
        fontWeight: 700,
    },
    AgeType: {
        color: 'var(--Fonts-Primary-Variant, #6E6893)',
    
        fontFeatureSettings: "'clig' off, 'liga' off",
        fontFamily: 'Montserrat',
        fontSize: '17px',
        fontStyle: 'normal',
        fontWeight: 400,
    },
};

export default styles;